import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { METARS_LEGEND } from './metars.legend';
import { METARS_PRODUCT_DATA } from './metars.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class MetarsPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(METARS_PRODUCT_DATA, {
    legend: METARS_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
